import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import { buildCurrentUrlData, getSavedState, getEmptyData, getEmptySelection, removeVehicleFilters } from '../helpers/cardanDataHelpers';
import { ACTIONS } from '../constants';
var createInitialState = function createInitialState() {
  var savedState = getSavedState();
  return {
    compatibility: null,
    data: getEmptyData(),
    error: null,
    loading: false,
    pendingFetch: false,
    pendingReloadPage: false,
    plateError: null,
    selected: _extends({}, getEmptySelection(), savedState == null ? void 0 : savedState.selected),
    uiState: _extends({
      showSummary: false
    }, savedState == null ? void 0 : savedState.uiState)
  };
};
var useCardanDataReducer = function useCardanDataReducer() {
  var handleChangeBrand = function handleChangeBrand(state, action) {
    var _action$payload = action == null ? void 0 : action.payload,
      id = _action$payload.id,
      urlLogo = _action$payload.urlLogo;
    return _extends({}, state, {
      data: _extends({}, state == null ? void 0 : state.data, {
        models: [],
        versions: [],
        years: []
      }),
      pendingFetch: true,
      selected: _extends({}, state == null ? void 0 : state.selected, {
        brand: id,
        brandLogo: urlLogo || null,
        model: null,
        version: null,
        year: null
      })
    });
  };
  var handleChangeModel = function handleChangeModel(state, action) {
    return _extends({}, state, {
      data: _extends({}, state == null ? void 0 : state.data, {
        versions: [],
        years: []
      }),
      pendingFetch: true,
      selected: _extends({}, state == null ? void 0 : state.selected, {
        model: action == null ? void 0 : action.payload,
        version: null,
        year: null
      })
    });
  };
  var handleChangeVersion = function handleChangeVersion(state, action) {
    return _extends({}, state, {
      selected: _extends({}, state == null ? void 0 : state.selected, {
        version: action == null ? void 0 : action.payload
      })
    });
  };
  var handleChangeYear = function handleChangeYear(state, action) {
    return _extends({}, state, {
      data: _extends({}, state == null ? void 0 : state.data, {
        versions: []
      }),
      pendingFetch: true,
      selected: _extends({}, state == null ? void 0 : state.selected, {
        version: null,
        year: action == null ? void 0 : action.payload
      })
    });
  };
  var handleResetAll = function handleResetAll(state) {
    var _state$selected;
    var currentUrl = removeVehicleFilters(buildCurrentUrlData(state == null ? void 0 : (_state$selected = state.selected) == null ? void 0 : _state$selected.searchUrl));
    return _extends({}, state, {
      data: _extends({}, state == null ? void 0 : state.data, {
        models: [],
        versions: [],
        years: []
      }),
      pendingFetch: true,
      pendingReloadPage: true,
      selected: _extends({}, getEmptySelection(), {
        searchUrl: currentUrl
      }),
      uiState: {
        showSummary: false
      }
    });
  };
  var handleSaveSearchUrl = function handleSaveSearchUrl(state, action) {
    return _extends({}, state, {
      pendingFetch: false,
      pendingReloadPage: true,
      selected: _extends({}, state == null ? void 0 : state.selected, {
        searchUrl: action == null ? void 0 : action.payload
      })
    });
  };
  var handleChangeCarPlate = function handleChangeCarPlate(state, action) {
    return _extends({}, state, {
      selected: _extends({}, state == null ? void 0 : state.selected, {
        carPlate: action == null ? void 0 : action.payload
      })
    });
  };
  var handleChangeVehicleDetails = function handleChangeVehicleDetails(state, action) {
    return _extends({}, state, {
      selected: _extends({}, state == null ? void 0 : state.selected, {
        vehicleDetails: action == null ? void 0 : action.payload
      })
    });
  };
  var handleSetShowSummary = function handleSetShowSummary(state, action) {
    var updatedUiState = _extends({}, state == null ? void 0 : state.uiState, {
      showSummary: action == null ? void 0 : action.payload
    });
    return _extends({}, state, {
      uiState: updatedUiState
    });
  };
  var handleChangeCompatibility = function handleChangeCompatibility(state, action) {
    return _extends({}, state, {
      compatibility: action == null ? void 0 : action.payload,
      pendingFetch: false
    });
  };
  var cardanReducer = function cardanReducer(state, action) {
    if (!(action == null ? void 0 : action.type) && !(action == null ? void 0 : action.payload)) return state;
    switch (action.type) {
      case ACTIONS.CHANGE_BRAND:
        return handleChangeBrand(state, action);
      case ACTIONS.CHANGE_MODEL:
        return handleChangeModel(state, action);
      case ACTIONS.CHANGE_VERSION:
        return handleChangeVersion(state, action);
      case ACTIONS.CHANGE_YEAR:
        return handleChangeYear(state, action);
      case ACTIONS.FETCH_START:
        return _extends({}, state, {
          pendingFetch: false
        });
      case ACTIONS.RELOAD_PAGE_START:
        return _extends({}, state, {
          pendingReloadPage: false
        });
      case ACTIONS.RESET_ALL:
        return handleResetAll(state);
      case ACTIONS.SAVE_SEARCH_URL:
        return handleSaveSearchUrl(state, action);
      case ACTIONS.SET_COMPATIBILITY:
        return handleChangeCompatibility(state, action);
      case ACTIONS.SET_DATA:
        return _extends({}, state, {
          data: _extends({}, state == null ? void 0 : state.data, _defineProperty({}, action.entity, action == null ? void 0 : action.payload)),
          pendingFetch: false
        });
      case ACTIONS.SET_ERROR:
        return _extends({}, state, {
          error: action == null ? void 0 : action.payload,
          pendingFetch: false
        });
      case ACTIONS.SET_LOADING:
        return _extends({}, state, {
          loading: action == null ? void 0 : action.payload
        });
      case ACTIONS.SET_SHOW_SUMMARY:
        return handleSetShowSummary(state, action);
      case ACTIONS.SET_CAR_PLATE:
        return handleChangeCarPlate(state, action);
      case ACTIONS.SET_PLATE_ERROR:
        return _extends({}, state, {
          plateError: action == null ? void 0 : action.payload
        });
      case ACTIONS.SET_VEHICLE_DETAILS:
        return handleChangeVehicleDetails(state, action);
      default:
        return state;
    }
  };
  return {
    cardanReducer: cardanReducer,
    createInitialState: createInitialState
  };
};
export default useCardanDataReducer;